import { render, staticRenderFns } from "./perview-image.vue?vue&type=template&id=0f57a260&"
import script from "./perview-image.vue?vue&type=script&lang=js&"
export * from "./perview-image.vue?vue&type=script&lang=js&"
import style0 from "./perview-image.vue?vue&type=style&index=0&id=0f57a260&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports